export default __webpack_public_path__ + "09da1c967c31bba0ce809f2fd686fe43.png";